import React, { useRef } from 'react';
import { useWavesurfer } from '@wavesurfer/react';
import { AudioWaveSurferContainer } from './Audio.styles';

type AudioWaveSurferProps = {
  id: string;
  url: string;
  height?: number;
  waveColor?: string;
  progressColor?: string;
  cursorColor?: string;
  barWidth?: number;
};

const AudioWaveSurfer: React.FC<AudioWaveSurferProps> = ({
  id,
  url,
  height = 136,
  waveColor = '#F74C20',
  progressColor = '#D2588B',
  cursorColor = '#D8CFE4',
}) => {
  const containerRef = useRef(null);

  const { wavesurfer, isReady, isPlaying, currentTime } = useWavesurfer({
    container: containerRef,
    /** The height of the waveform in pixels */
    height,
    // /** The width of the waveform in pixels or any CSS value; defaults to 100% */
    // width: 300,
    /** Stretch the waveform to the full height */
    normalize: false,
    /** The color of the waveform */
    waveColor,
    /** The color of the progress mask */
    progressColor,
    /** The color of the playback cursor */
    cursorColor,
    /** The cursor width */
    cursorWidth: 2,
    /** Render the waveform with bars like this: ▁ ▂ ▇ ▃ ▅ ▂ */
    barWidth: NaN,
    /** Spacing between bars in pixels */
    barGap: NaN,
    /** Rounded borders for bars */
    barRadius: NaN,
    /** A vertical scaling factor for the waveform */
    barHeight: 1.25,
    /** Minimum pixels per second of audio (i.e. zoom level) */
    minPxPerSec: 1,
    /** Stretch the waveform to fill the container, true by default */
    fillParent: true,
    /** Whether to show default audio element controls */
    mediaControls: true,
    /** Play the audio on load */
    autoplay: false,
    /** Pass false to disable clicks on the waveform */
    interact: true,
    /** Allow to drag the cursor to seek to a new position */
    dragToSeek: false,
    /** Hide the scrollbar */
    hideScrollbar: false,
    /** Audio rate */
    audioRate: 1,
    /** Automatically scroll the container to keep the current position in viewport */
    autoScroll: true,
    /** If autoScroll is enabled, keep the cursor in the center of the waveform during playback */
    autoCenter: true,
    /** Decoding sample rate. Doesn't affect the playback. Defaults to 8000 */
    sampleRate: 8000,
    url,
    // url: 'https://www.zsl.ddev.site/test/file_example_MP3_700KB.mp3', // Todo: Resolve the cors policy on zsl main site.
  });

  return (
    <AudioWaveSurferContainer id={`audio-player-${id}`} className="audio-players" ref={containerRef}>
    </AudioWaveSurferContainer>
  );
};

export default AudioWaveSurfer;
